export default "__VITE_ASSET__2f1196d5__"